module.exports = __webpack_public_path__ + "img/empty_box.c4231e16.png";